import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/category/recent?limit=N -> bare array of the N distinct active,
// non-deleted categories whose products changed most recently (newest first).
export default function useRecentCategories(limit = 4) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    client
      .get('/category/recent', { params: { limit } })
      .then(({ data }) => {
        if (!active) return;
        setCategories(Array.isArray(data) ? data : []);
        setError(null);
      })
      .catch((err) => {
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [limit]);

  return { categories, loading, error };
}
